export default __webpack_public_path__ + "static/media/banneradimg.3abc5f06.png";